import { DescribeMlValue, MlValueText } from '../../utils/mlPayloadValues';
import { Mono } from '../ui/Mono';

/**
 * Um valor do JSON do Mercado Livre desenhado para leitura: dinheiro formatado,
 * objeto em pares chave: valor, lista com a contagem e os primeiros itens.
 * A árvore vem de `DescribeMlValue` (utils/mlPayloadValues.js).
 */
const NodeView = ({ node }) => {
    if (node.kind === 'text') {
        return <Mono className="break-all">{node.text}</Mono>;
    }

    if (node.kind === 'list') {
        const rest = node.total - node.items.length;
        return (
            <div>
                <span className="text-mono-500 dark:text-mono-400">
                    {node.total} {node.total === 1 ? 'item' : 'itens'}
                </span>
                <ul className="ml-4 list-disc space-y-0.5">
                    {node.items.map((item, index) => (
                        <li key={index}>
                            <NodeView node={item} />
                        </li>
                    ))}
                </ul>
                {rest > 0 ? (
                    <span className="text-mono-500 dark:text-mono-400">e mais {rest} na resposta crua</span>
                ) : null}
            </div>
        );
    }

    const rest = node.total - node.pairs.length;
    return (
        <div>
            <dl className="grid grid-cols-[auto_minmax(0,1fr)] gap-x-2 gap-y-0.5">
                {node.pairs.map((pair) => (
                    <div key={pair.key} className="contents">
                        <dt className="text-mono-500 dark:text-mono-400">
                            <Mono>{pair.key}:</Mono>
                        </dt>
                        <dd className="min-w-0 text-mono-800 dark:text-mono-200">
                            <NodeView node={pair.value} />
                        </dd>
                    </div>
                ))}
            </dl>
            {rest > 0 ? (
                <span className="text-mono-500 dark:text-mono-400">e mais {rest} campos na resposta crua</span>
            ) : null}
        </div>
    );
};

export const MlValue = ({ value, fieldKey = null, currency = 'BRL' }) => {
    const node = DescribeMlValue(value, { key: fieldKey, currency });
    return (
        <div title={node.kind === 'text' ? undefined : MlValueText(node)}>
            <NodeView node={node} />
        </div>
    );
};

export default MlValue;
